module.exports = {"pagination":{"ListSignalingChannels":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ChannelInfoList"},"ListStreams":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"StreamInfoList"}}}


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/kinesisvideo-2017-09-30.paginators.json
// module id = 722
// module chunks = 2